import { X } from "lucide-react";

import { AvailabilityPeriodForm } from "./AvailabilityPeriodForm";
import { DurationRuleForm, TravelRuleForm } from "./AvailabilityRuleForms";
import type { AvailabilitySection } from "./AvailabilityPage";
import type {
  ScopedAvailability,
  ServiceDurationRule,
  ServiceType,
  TravelBufferRule,
  WorkforceOverview,
} from "./types";

type AvailabilityRecord = ScopedAvailability | ServiceDurationRule | TravelBufferRule;
export type AvailabilitySelection = { kind: AvailabilitySection; record?: AvailabilityRecord };

const names = {
  timeOff: "time-off period",
  scheduleBlocks: "schedule block",
  durationRules: "duration rule",
  travelBufferRules: "travel buffer",
} as const;

export function AvailabilityEditor({
  selection,
  workforce,
  services,
  canWrite,
  onClose,
  onSaved,
}: {
  selection: AvailabilitySelection;
  workforce: WorkforceOverview;
  services: ServiceType[];
  canWrite: boolean;
  onClose: () => void;
  onSaved: () => Promise<void>;
}) {
  const title = `${selection.record ? "Edit" : "Add"} ${names[selection.kind]}`;
  return (
    <div className="client-drawer-backdrop" onMouseDown={onClose}>
      <section
        className="client-drawer availability-drawer"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="drawer-header">
          <div>
            <span className="eyebrow lime">Scheduling configuration</span>
            <h2>{title}</h2>
          </div>
          <button className="icon-button" aria-label="Close availability record" onClick={onClose}>
            <X />
          </button>
        </header>
        <div className="drawer-body">
          {selection.kind === "timeOff" || selection.kind === "scheduleBlocks" ? (
            <AvailabilityPeriodForm
              kind={selection.kind}
              record={selection.record as ScopedAvailability | undefined}
              workforce={workforce}
              canWrite={canWrite}
              onClose={onClose}
              onSaved={onSaved}
            />
          ) : null}
          {selection.kind === "durationRules" ? (
            <DurationRuleForm
              record={selection.record as ServiceDurationRule | undefined}
              services={services}
              canWrite={canWrite}
              onClose={onClose}
              onSaved={onSaved}
            />
          ) : null}
          {selection.kind === "travelBufferRules" ? (
            <TravelRuleForm
              record={selection.record as TravelBufferRule | undefined}
              regions={workforce.regions}
              canWrite={canWrite}
              onClose={onClose}
              onSaved={onSaved}
            />
          ) : null}
        </div>
      </section>
    </div>
  );
}
